import React from "react";
import { Play, Lock, X, Bell, ChevronRight } from "lucide-react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATUS_STYLE = {
  DRAFT:       "text-white/40 bg-white/5 border-white/10",
  OPEN:        "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  REVIEW:      "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  CALIBRATION: "text-blue-400 bg-blue-500/10 border-blue-500/20",
  CLOSED:      "text-white/25 bg-white/5 border-white/10",
};

export default function CycleActionsBar({ cycle, onStart, onBulkNudge, onLock, onClose }) {
  const status     = cycle?.status;
  const canStart   = !status || status === "DRAFT";
  const inReview   = status === "REVIEW" || status === "OPEN";
  const inCalib    = status === "CALIBRATION";
  const statusStyle = STATUS_STYLE[status] || STATUS_STYLE.DRAFT;

  return (
    <div className={`${card} px-5 py-4 flex flex-wrap items-center gap-3`}>
      <div className="flex items-center gap-2 mr-2">
        <span className="text-xs text-white/30 uppercase tracking-wider">Cycle Status</span>
        <span className={`text-xs px-2.5 py-1 rounded-full border font-medium ${statusStyle}`}>
          {status || "No Active Cycle"}
        </span>
        {cycle?.name && <span className="text-xs text-white/30">· {cycle.name}</span>}
      </div>

      <div className="flex flex-wrap gap-2 ml-auto">
        <button onClick={onStart} disabled={!canStart}
          className="flex items-center gap-1.5 text-xs px-4 py-2 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] disabled:opacity-30 transition-colors">
          <Play size={12} /> Start Cycle
        </button>
        <button onClick={() => onBulkNudge?.("Self")} disabled={!inReview}
          className="flex items-center gap-1.5 text-xs px-3 py-2 rounded-lg border border-white/10 bg-white/5 text-white/50 hover:bg-white/10 hover:text-white disabled:opacity-30 transition-colors">
          <Bell size={12} /> Nudge Self
        </button>
        <button onClick={() => onBulkNudge?.("Mgr")} disabled={!inReview}
          className="flex items-center gap-1.5 text-xs px-3 py-2 rounded-lg border border-white/10 bg-white/5 text-white/50 hover:bg-white/10 hover:text-white disabled:opacity-30 transition-colors">
          <Bell size={12} /> Nudge Managers
        </button>
        <button onClick={onLock} disabled={!inReview}
          className="flex items-center gap-1.5 text-xs px-4 py-2 rounded-lg border border-blue-500/25 bg-blue-500/8 text-blue-400/70 hover:bg-blue-500/15 hover:text-blue-400 disabled:opacity-30 transition-colors">
          <Lock size={12} /> Lock for Calibration
        </button>
        <button onClick={onClose} disabled={!inCalib}
          className="flex items-center gap-1.5 text-xs px-4 py-2 rounded-lg border border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400 disabled:opacity-30 transition-colors">
          <X size={12} /> Close Cycle
        </button>
      </div>
    </div>
  );
}